<template>
  <div class="learning-card-content" v-if="card">
    <p v-if="showTitle && card.displayName" class="text-h6 font-weight-bold">
      {{ card.displayName }}
    </p>
    <LearningMediaDisplay v-if="showMedia" :card="card" :context="context" class="mt-6" />
    <div
      v-if="showContent && hasContentBody"
      class="ql-editor text-left mt-4"
      v-html="card.content"
    />
  </div>
</template>

<script>
import LearningMediaDisplay from "@/components/learning/LearningMediaDisplay.vue";

export default {
  name: "LearningCardContent",
  components: {
    LearningMediaDisplay,
  },
  props: {
    /** Learning card object (displayName, content, contentUrlSigned, type, etc.). */
    card: {
      type: Object,
      default: null,
    },
    /** Show the card title (displayName). */
    showTitle: {
      type: Boolean,
      default: true,
    },
    /** Show rich-text content body (when card is not quiz/survey/assessment/learning_resources). */
    showContent: {
      type: Boolean,
      default: true,
    },
    /** Show media (image, PDF, video, transcript) via LearningMediaDisplay. */
    showMedia: {
      type: Boolean,
      default: true,
    },
    /** Context passed to LearningMediaDisplay (e.g. 'survey'). */
    context: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    hasContentBody() {
      const c = this.card;
      if (!c?.content) return false;
      const type = c.type;
      if (type && ["quiz", "survey", "assessment", "learning_resources"].includes(type)) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.learning-card-content {
  width: 100%;
}
</style>
